import { SIMPLVmTable } from "../../SimplVmTable";

export const SimplVmPostProvisioning = () => (
  <SIMPLVmTable
    type="post-provisioning-operations"
    addButtonLabel="Add Post-Provisioning"
    addModalTitle="Post-Provisioning"
    contentLabel="Commands"
    contentMessage="Commands are required"
  />
);